import type { EnquiryMore } from "./enquiry-helpers";

const normalizeMoreRecord = (raw: Record<string, unknown>): EnquiryMore => ({
    formType:
        typeof raw.formType === "string"
            ? raw.formType
            : typeof raw.form_type === "string"
              ? raw.form_type
              : undefined,
    category: typeof raw.category === "string" ? raw.category : undefined,
    currentRole:
        typeof raw.currentRole === "string"
            ? raw.currentRole
            : typeof raw.current_role === "string"
              ? raw.current_role
              : undefined,
    linkedin: typeof raw.linkedin === "string" ? raw.linkedin : undefined,
    experience: typeof raw.experience === "string" ? raw.experience : undefined,
    resume: typeof raw.resume === "string" ? raw.resume : undefined,
});

export const parseMoreValue = (raw: EnquiryMore | string | null | undefined): EnquiryMore => {
    if (raw == null || raw === "") return {};
    if (typeof raw === "object") return normalizeMoreRecord(raw as Record<string, unknown>);

    try {
        let parsed: unknown = JSON.parse(raw);
        if (typeof parsed === "string") {
            try {
                parsed = JSON.parse(parsed);
            } catch {
                return {};
            }
        }
        if (parsed != null && typeof parsed === "object") {
            return normalizeMoreRecord(parsed as Record<string, unknown>);
        }
    } catch {
        return {};
    }

    return {};
};
